
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/island",
      function () {
        return require("private-next-pages/island/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/island"])
      });
    }
  